import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from '../lib/axios';

const postProduct = async (form, id) => {
    try {
        const {
            brand, name, description, sku_id, manufacturer, distributor,
            category, is_featured, warranty, disposable, usage, attributes,
            images, highlights, ingredients, sterility, replacementPolicy, isPriceDisplay, specification, fda, notes, displayNotes, customWarranty,material
        } = form;

        const formData = new FormData();

        // Required Fields
        formData.append("brand", brand);
        formData.append("fda", fda);
        formData.append("name", name);
        formData.append("description", description);
        formData.append("category", category);
        formData.append("sku_id", sku_id);
        formData.append("is_featured", is_featured);
        formData.append("disposable", true);
        formData.append("usage", usage || "");
        formData.append("sterility", sterility || "");
        formData.append("replacementPolicy", replacementPolicy || "");
        formData.append("isPriceDisplay", isPriceDisplay);
        formData.append("notes", notes);
        formData.append("displayNotes", displayNotes);
        formData.append("material", material);

        if (warranty === 'custom') formData.append("warranty", customWarranty);
        else formData.append("warranty", warranty || "");

        if (manufacturer) formData.append("manufacturer", manufacturer);
        if (distributor) formData.append("distributor", distributor);

        if (highlights.length > 0) {
            for (let i = 0; i < (highlights || []).length; i++) {
                formData.append("highlights[]", highlights[i]);
            }
        }

        if (specification.length > 0) {
            for (let i = 0; i < (specification || []).length; i++) {
                formData.append("specification[]", specification[i]);
            }
        }

        if (ingredients.length > 0) {
            for (let i = 0; i < (ingredients || []).length; i++) {
                formData.append("ingredients[]", ingredients[i]);
            }
        }

        if (images.length > 0) {
            for (let i = 0; i < (images || []).length; i++) {

                if (typeof images[i] === "string")
                    formData.append("images", images[i]);
                else {
                    formData.append("pictures", images[i]);
                }
            }
        }


        formData.append("attributes", JSON.stringify(attributes));

        if (id) {
            formData.append("id", id);
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/product`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        console.log("product", res)
        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

const getAllProduct = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/product?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        // console.log(res)
        // toast.success("Successfully fetched!");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}
const getProductByIdFunction = async (id) => {
    try {

        const params = new URLSearchParams();
        params.append('id', id);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/product/id?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully fetched!");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const deleteProduct = async (id) => {
    try {

        if (!id) {
            toast.error("id is not present");
        }
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.delete(`/product/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully deleted!");
        // return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const dowloadProduct = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/product/dowload?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            responseType: "arraybuffer",
        })

        const blob = new Blob([res.data], { type: "application/pdf" });

        // Create a download link and simulate click
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "product-details.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up
        window.URL.revokeObjectURL(link.href);

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export {
    postProduct,
    getAllProduct,
    deleteProduct,
    dowloadProduct,
    getProductByIdFunction
};
